import { calculateSums } from '../quote-editor/utils/calculate-derived-values';
import { tapFlashError } from './flash';

// compare the budgets of a current quote with the initial quote budgets
// and throws an error if any of these ones have increased or decreased

export default function compareTotalBudgetsQuote(
  initialQuote,
  quote,
  quoteLinesById,
) {
  const initialQuoteLines = Object.values(initialQuote.quoteLinesById);

  const initialBudgetsSum = calculateSums(
    initialQuoteLines,
    initialQuote.quote.headerDiscountPercent,
  );

  const budgetsSum = calculateSums(
    Object.values(quoteLinesById),
    quote.headerDiscountPercent,
  );

  const { netClientBudgetExternal, wkzBudget, coInvest, freeServiceValue } =
    initialBudgetsSum;

  const hasAnyBudgetChanged =
    netClientBudgetExternal !== budgetsSum.netClientBudgetExternal ||
    wkzBudget !== budgetsSum.wkzBudget ||
    coInvest !== budgetsSum.coInvest ||
    freeServiceValue !== budgetsSum.freeServiceValue;

  if (hasAnyBudgetChanged) {
    tapFlashError()({
      message: `Make sure to set the budgets according to the initial contract (Net Client Budget External: ${netClientBudgetExternal}, Net Client Budget WKZ: ${wkzBudget}, Coinvest: ${coInvest}, Free Media: ${freeServiceValue})`,
    });
  }
}
